import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const mutation = graphql`
  mutation AccountUpdateMutation($input: UpdateAccountTByAccountIdInput!) {
    updateAccountTByAccountId(input: $input) {
      accountT {
        accountId
        accountName
        accountNum
        description
        accountStatus
        contactLastName
        contactFirstName
        contactEmail
        contactPhone
        address1
        address2
        city
        state
        country
        postalCode
        logo
        sendMonthlyStatement
        billingDayOfMonth
        achActive
        maxCharge
        floatLimit
        requestedFloatLimit
        floatBalance
        invoiceInformation
        useBudgets
        mccAuth
        mccWhitelist
        feeMonthly
        feeCustPercentage
        feeSelfPercentage
        plaidCheckPercAllow
        achLimitNopeek
        achLimitAbsolute
        achPercAvailableOnCharge
        achMinAvailableOnCharge
        ccPercAvailableOnCharge
        ccMinAvailableOnCharge
    
      }
    }
  }
  `;

  function commit(accountId, accountName, accountNum, description, accountStatus,
                  contactLastName, contactFirstName, contactEmail, contactPhone,
                  address1, address2, city, state, country, postalCode,
                  logo, billingDayOfMonth, maxCharge, floatLimit, sendMonthlyStatement, achActive, invoiceInformation, useBudgets, mccAuth, mccWhitelist,
                  feeMonthly, feeCustPercentage, feeSelfPercentage, requestedFloatLimit, plaidCheckPercAllow, achLimitNopeek, achLimitAbsolute,  
                  achPercAvailableOnCharge, achMinAvailableOnCharge, ccPercAvailableOnCharge, ccMinAvailableOnCharge ) {
    var variables = {
        input: {
            accountId,
            accountTPatch: {}
        }
    };

    if (accountName != null)
        variables.input.accountTPatch.accountName = accountName;
    if (accountNum != null)
        variables.input.accountTPatch.accountNum = accountNum;
    if (description != null)
        variables.input.accountTPatch.description = description;
    if (accountStatus != null)
        variables.input.accountTPatch.accountStatus = accountStatus;
    if (contactLastName != null)
        variables.input.accountTPatch.contactLastName = contactLastName;
    if (contactFirstName != null)
        variables.input.accountTPatch.contactFirstName = contactFirstName;
    if (contactEmail != null)
        variables.input.accountTPatch.contactEmail = contactEmail;
    if (contactPhone != null)
        variables.input.accountTPatch.contactPhone = contactPhone;    
    if (address1 != null)
        variables.input.accountTPatch.address1 = address1;
    if (address2 != null)
        variables.input.accountTPatch.address2 = address2;
    if (city != null)
        variables.input.accountTPatch.city = city;
    if (state != null)
        variables.input.accountTPatch.state = state;
    if (country != null)
        variables.input.accountTPatch.country = country;
    if (postalCode != null)
        variables.input.accountTPatch.postalCode = postalCode;  
    if (logo != null)
        variables.input.accountTPatch.logo = logo;  
    if (billingDayOfMonth != null)
        variables.input.accountTPatch.billingDayOfMonth = billingDayOfMonth;
    if (maxCharge != null)
        variables.input.accountTPatch.maxCharge = maxCharge;
    if (floatLimit != null)
        variables.input.accountTPatch.floatLimit = floatLimit;
    if (requestedFloatLimit != null)
        variables.input.accountTPatch.requestedFloatLimit = requestedFloatLimit;
    if (sendMonthlyStatement != null)
        variables.input.accountTPatch.sendMonthlyStatement = sendMonthlyStatement;
    if (achActive != null)
        variables.input.accountTPatch.achActive = achActive;
    if (invoiceInformation != null)
        variables.input.accountTPatch.invoiceInformation = invoiceInformation;
    if (useBudgets != null) {
        variables.input.accountTPatch.useBudgets = useBudgets;
        if (useBudgets > 0) {
            variables.input.accountTPatch.payFromBalance = 1;
        } else if (useBudgets === 0) {
            variables.input.accountTPatch.payFromBalance = 0;
        }
    }
    if (mccAuth != null)
        variables.input.accountTPatch.mccAuth = mccAuth;
    if (mccWhitelist != null) {
      if (mccWhitelist === '') {
        variables.input.accountTPatch.mccWhitelist = null;
      } else {
        variables.input.accountTPatch.mccWhitelist = mccWhitelist;
      }
    }
    if (feeMonthly != null) {
        variables.input.accountTPatch.feeMonthly = feeMonthly;
    }
    if (feeCustPercentage != null) {
        variables.input.accountTPatch.feeCustPercentage = feeCustPercentage;
    }
    if (feeSelfPercentage != null) {
        variables.input.accountTPatch.feeSelfPercentage = feeSelfPercentage;
    }

    if (plaidCheckPercAllow != null) {
        variables.input.accountTPatch.plaidCheckPercAllow = plaidCheckPercAllow;
    }
    if (achLimitNopeek != null) {
        variables.input.accountTPatch.achLimitNopeek = achLimitNopeek;
    }
    if (achLimitAbsolute != null) {
        variables.input.accountTPatch.achLimitAbsolute = achLimitAbsolute;
    }
    if (achPercAvailableOnCharge != null) {
        variables.input.accountTPatch.achPercAvailableOnCharge = achPercAvailableOnCharge;
    }
    if (achMinAvailableOnCharge != null) {
        variables.input.accountTPatch.achMinAvailableOnCharge = achMinAvailableOnCharge;
    }
    if (ccPercAvailableOnCharge != null) {
        variables.input.accountTPatch.ccPercAvailableOnCharge = ccPercAvailableOnCharge;
    }
    if (ccMinAvailableOnCharge != null) {
        variables.input.accountTPatch.ccMinAvailableOnCharge = ccMinAvailableOnCharge;
    }

    return new Promise((resolve, reject) => {
        commitMutation(
            abEnvironment.getEnvironment(), {
              mutation,
              variables,
              updater: (store) => {
                // Mutation store - values that have been updated / returned
                const payload = store.getRootField('updateAccountTByAccountId');
                const theAccount = payload.getLinkedRecord('accountT');

                // Retrieved store - assumes that all callers are components that have queried
                // account using 'accountTByAccountId'.
                const theRoot = store.getRoot();
                const preSaveAccountId = 'accountTByAccountId(accountId:"' + accountId + '")';
                const preSaveAccount = theRoot.getLinkedRecord(preSaveAccountId);

                // Could restrict to just what has changed, but just do all returned values,
                // which is correct.
                if (preSaveAccount != null) {
                  preSaveAccount.setValue(theAccount.getValue('accountName'),       'accountName');
                  preSaveAccount.setValue(theAccount.getValue('accountNum'),        'accountNum');
                  preSaveAccount.setValue(theAccount.getValue('description'),       'description');
                  preSaveAccount.setValue(theAccount.getValue('accountStatus'),     'accountStatus');
                  preSaveAccount.setValue(theAccount.getValue('contactLastName'),   'contactLastName');
                  preSaveAccount.setValue(theAccount.getValue('contactFirstName'),  'contactFirstName');
                  preSaveAccount.setValue(theAccount.getValue('contactEmail'),      'contactEmail');
                  preSaveAccount.setValue(theAccount.getValue('contactPhone'),      'contactPhone');
                  preSaveAccount.setValue(theAccount.getValue('address1'),          'address1');
                  preSaveAccount.setValue(theAccount.getValue('address2'),          'address2');
                  preSaveAccount.setValue(theAccount.getValue('city'),              'city');
                  preSaveAccount.setValue(theAccount.getValue('state'),             'state');
                  preSaveAccount.setValue(theAccount.getValue('country'),           'country');
                  preSaveAccount.setValue(theAccount.getValue('postalCode'),        'postalCode');
                  preSaveAccount.setValue(theAccount.getValue('logo'),              'logo');
                  preSaveAccount.setValue(theAccount.getValue('billingDayOfMonth'), 'billingDayOfMonth');
                  preSaveAccount.setValue(theAccount.getValue('maxCharge'),         'maxCharge');
                  preSaveAccount.setValue(theAccount.getValue('floatLimit'),        'floatLimit');
                  preSaveAccount.setValue(theAccount.getValue('requestedFloatLimit'),  'requestedFloatLimit');
                  preSaveAccount.setValue(theAccount.getValue('sendMonthlyStatement'), 'sendMonthlyStatement');
                  preSaveAccount.setValue(theAccount.getValue('achActive'),          'achActive');
                  preSaveAccount.setValue(theAccount.getValue('invoiceInformation'), 'invoiceInformation');
                  preSaveAccount.setValue(theAccount.getValue('useBudgets'),         'useBudgets');
                  preSaveAccount.setValue(theAccount.getValue('mccAuth'),            'mccAuth');
                  preSaveAccount.setValue(theAccount.getValue('mccWhitelist'),       'mccWhitelist');
                  preSaveAccount.setValue(theAccount.getValue('feeMonthly'),         'feeMonthly');
                  preSaveAccount.setValue(theAccount.getValue('feeCustPercentage'),  'feeCustPercentage');
                  preSaveAccount.setValue(theAccount.getValue('feeSelfPercentage'), 'feeSelfPercentage');   
                  preSaveAccount.setValue(theAccount.getValue('plaidCheckPercAllow'), 'plaidCheckPercAllow');   
                  preSaveAccount.setValue(theAccount.getValue('achLimitNopeek'), 'achLimitNopeek');   
                  preSaveAccount.setValue(theAccount.getValue('achLimitAbsolute'), 'achLimitAbsolute');   
                  preSaveAccount.setValue(theAccount.getValue('achPercAvailableOnCharge'), 'achPercAvailableOnCharge');   
                  preSaveAccount.setValue(theAccount.getValue('achMinAvailableOnCharge'), 'achMinAvailableOnCharge');   
                  preSaveAccount.setValue(theAccount.getValue('ccPercAvailableOnCharge'), 'ccPercAvailableOnCharge');   
                  preSaveAccount.setValue(theAccount.getValue('ccMinAvailableOnCharge'), 'ccMinAvailableOnCharge');   
                }
              },
              onCompleted: (response) => {
                resolve(response);
              },
              onError: (error) => {
                reject(error);
              }
        }); 
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  